import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  faultReports: [],
  filter: {},
  isLoadingFaultReports: false,
  isLoading: false,
  error: null,
  faultReportsDownload: [],
  isLoadingFaultReportsDownload: false,
};

export const getFaultReports: any = createAsyncThunk(
  "content/getFaultReports",
  async ({
    PageNumber,
    pageSize,
    tcCode = "",
    siteCode = "",
    blockCode = "",
    reportType = "",
    startDate = "",
    endDate = "",
    SortBy,
    SortDirection,
    isAcknowledged,
  }: any) => {
    const payload = {
      PageNumber,
      pageSize,
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
      SortBy,
      SortDirection,
      isAcknowledged,
    };

    const res = await axios.post(`/slpapp/Report/getFaultReport`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  },
);

export const downloadFaultReportsFile: any = createAsyncThunk(
  "content/downloadFaultReportsFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    isAcknowledged = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
      isAcknowledged,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getFaultReport/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  },
);

export const getAllFaultType: any = createAsyncThunk(
  "content/getAllFaultType",
  async () => {
    const res = await axios.get(`/slpapp/Report/getAllFaultType`);
    const data = await res?.data;
    return data;
  },
);

export const faultReportSlice = createSlice({
  name: "faultReport",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFaultReports.pending, (state) => {
      state.isLoadingFaultReports = true;
    });
    builder.addCase(getFaultReports.fulfilled, (state, action) => {
      state.isLoadingFaultReports = false;
      state.faultReports = action.payload;
    });
    builder.addCase(getFaultReports.rejected, (state, action) => {
      state.isLoadingFaultReports = false;
      state.error = action.error.message;
    });

    builder.addCase(downloadFaultReportsFile.pending, (state) => {
      state.isLoadingFaultReportsDownload = true;
    });
    builder.addCase(downloadFaultReportsFile.fulfilled, (state, action) => {
      state.isLoadingFaultReportsDownload = false;
      state.faultReportsDownload = action.payload;
    });
    builder.addCase(downloadFaultReportsFile.rejected, (state, action) => {
      state.isLoadingFaultReportsDownload = false;
      state.error = action.error.message;
    });
  },
});

export const { setFilter } = faultReportSlice.actions;

export default faultReportSlice.reducer;
